export const getFormattedLink = (link: string | undefined) => {
  if (!link) {
    return '';
  } else if (link.startsWith('http://') || link.startsWith('https://')) {
    return link;
  }
  return `/${link}/`;
};
